export default function initChart() {
  const iframes = document.querySelectorAll("iframe.chart")

  if (!iframes.length) return

  let scrollTimeout = null
  const frameHeights = {}

  window.addEventListener("message", (event) => {
    iframes.forEach((iframe) => {
      if (iframe.contentWindow === event.source) {
        const newHeight = event.data + 10
        const iframeId = iframe.src

        if (!frameHeights[iframeId] || frameHeights[iframeId] !== newHeight) {
          frameHeights[iframeId] = newHeight
          iframe.style.height = `${newHeight}px`
          iframe.style.overflow = "hidden"

          if (scrollTimeout) clearTimeout(scrollTimeout)

          if (window.location.hash) {
            scrollTimeout = setTimeout(() => {
              const element = document.querySelector(window.location.hash)
              if (element) {
                const scrollPosition = element.getBoundingClientRect().top + window.scrollY
                window.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
                })
              }
            }, 300)
          }
        }
      }
    })
  })

  // Cheat workaround for charts sometimes not rendering properly
  window.addEventListener(
    'load',
    () => window.dispatchEvent(new Event("resize"))
  )
}